export default "__VITE_ASSET__6e699993__"